module.exports = __webpack_public_path__ + "img/cup.7965040f.png";